export default class CustomError extends Error {
  constructor(message, type = "error") {
    super(message)
    this.type = type
  }
}
